import axios from "../../../api/axios";
import {AxiosRequestConfig} from "axios";
import {configNew} from "../../../config";

const config = (): AxiosRequestConfig => {
  return {
    ...configNew()
  }
}

export const apiAuth = (body: any) => axios.post(`/user/login`, body, config()).then(({data}) => data);
export const apiRegister = (body: any) => axios.post(`/user/register`, body, config()).then(({data}) => data);
export const apiRegisterConfirm = (body: any) => axios.post(`/user/confirm`, body, config()).then(({data}) => data);
export const apiRegisterVerification = (body: any) => axios.post(`/user/confirm`, body, config()).then(({data}) => data);
export const apiRegisterUpdate = (body: any) => axios.post(`/user/update-profile`, body, config()).then(({data}) => data);
export const apiRefreshToken = (body: any) => axios.post(`/user/refresh-token`, body, config()).then(({data}) => data);
export const apiRestore = (body: any) => axios.post(`/user/request-password-reset`, body, config()).then(({data}) => data);
export const apiGetSpecialists = (body: any) => axios.get(`/lists/specialist-types`,
  {
    params: body,
    ...config()
  }).then(({data}) => data);
export const apiGetProfile = () => axios.get(`/user/get-profile`,
  {
    ...config()
  }).then(({data}) => data);
export const apiGetModules = (body: any) => axios.get(`/user/get-modules`,
  {
    ...config()
  }).then(({data}) => data);
export const apiGetReviewsList = () => axios.get(`/reviews/list`,
  {
    ...config()
  }).then(({data}) => data);
export const apiResendCode = (data: { username: string }) =>
  axios
    .post(`/user/resend-confirmation-code`, data, { ...config() })
    .then(({ data }) => data);
export const apiConfirmResetPassword = (data: any) =>
  axios
    .post(`/user/confirm-reset-password`, data, { ...config() })
    .then(({ data }) => data);

export const apiConfirmPassword = (data: any) =>
  axios
    .post(`/user/confirm`, data, { ...config() })
    .then(({ data }) => data);
